var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -495,
    y: -397,
    width: 1419,
    height: 2054,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7946 6.44351C11.9348 6.58269 12.0461 6.74823 12.122 6.93059C12.1979 7.11296 12.237 7.30854 12.237 7.50608C12.237 7.70362 12.1979 7.89921 12.122 8.08157C12.0461 8.26394 11.9348 8.42948 11.7946 8.56865L8.56867 11.7946C8.4295 11.9348 8.26396 12.046 8.08159 12.122C7.89923 12.1979 7.70364 12.237 7.5061 12.237C7.30856 12.237 7.11298 12.1979 6.93061 12.122C6.74824 12.046 6.58271 11.9348 6.44353 11.7946L1.39058 6.74164L1.39058 2.36905C1.38985 2.24035 1.41466 2.11278 1.46358 1.99374C1.51249 1.87469 1.58454 1.76653 1.67555 1.67553C1.76655 1.58452 1.87471 1.51247 1.99376 1.46356C2.1128 1.41465 2.24037 1.38984 2.36907 1.39057L6.74166 1.39057L11.7946 6.44351Z",
    stroke: "#838991",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97749 5.97716C6.50522 5.44942 6.50522 4.59379 5.97749 4.06606C5.44975 3.53832 4.59413 3.53832 4.06639 4.06606C3.53865 4.59379 3.53865 5.44942 4.06639 5.97716C4.59412 6.50489 5.44975 6.50489 5.97749 5.97716Z",
    stroke: "#838991",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTag);
export default __webpack_public_path__ + "static/media/grey_tag.758b475319246d67ae6806890977bb5e.svg";
export { ForwardRef as ReactComponent };